const HeatedSeats = () => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.8333 38.4053C25.8525 37.1835 18.8421 38.5036 15.3972 39.9965C13.8637 40.661 13.5897 42.4578 14.3699 43.9359L16.4175 47.8156C17.1023 49.1131 18.4395 49.9315 19.9066 49.9483C25.6552 50.0139 35.1095 50.1243 38.9546 50.1944C44.8814 50.3026 48.2742 44.7784 49.9538 39.0935L56.6658 16.3757C56.8687 15.6889 56.354 15 55.6377 15C53.0462 15 50.4226 15.7558 48.9769 17.9066C46.0254 22.2976 43.7277 29.7151 42.3703 35.21C41.8664 37.2498 39.9235 38.6184 37.8333 38.4053Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M36.4065 32.5996C36.4065 32.9075 36.3989 33.3079 36.3969 33.768C36.3774 38.2802 38.0196 43.0617 36.4064 47.2758V47.2758C35.7341 49.0321 35.4578 52.1588 37.1823 53.7196M36.4065 32.5996L34.1924 34.96M36.4065 32.5996L38.5924 34.9299"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.9294 32.5996C28.9294 32.9125 28.92 33.3208 28.9178 33.7901C28.8965 38.3152 30.8182 43.1638 28.9293 47.2758V47.2758C28.1225 49.0321 27.7909 52.1588 29.8603 53.7196M28.9294 32.5996L26.2725 34.96M28.9294 32.5996L31.5525 34.9299"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4465 32.5997C21.4465 32.9076 21.439 33.308 21.437 33.7681C21.4175 38.2803 23.0597 43.0618 21.4465 47.2758V47.2758C20.7742 49.0321 20.4978 52.1588 22.2223 53.7196M21.4465 32.5997L19.2324 34.9601M21.4465 32.5997L23.6324 34.93"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HeatedSeats;
